import React, { useState, useEffect } from "react";
import { Row, Col, Button, Form, Alert, ProgressBar, Card, Table, Modal, ButtonGroup, Badge } from "react-bootstrap";
import axios from "axios";
import _ from "lodash";
import Utils from "../../common/Utils";
import JobSummary from "./JobSummary";
import JobResources from "./JobResources";
import JobEvidence from "./JobEvidence";
import EvidenceList from "../evidences/EvidenceList";
import moment from "moment";
import { useParams } from "react-router-dom";
import ChoosePlans from "../../components/application/ChoosePlans";
import VideoPlayer from "../../components/application/VideoPlayer";

const Jobs = (props) => {
  const [userData, setUserData] = useState(Utils.getUserData());
  const [requireEvidence, setRequireEvidence] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingJobs, setLoadingJobs] = useState(false);
  const [onLeave, setOnLeave] = useState(false);

  const [showVideo, setShowVideo] = useState("");

  const [showResourceList, setShowResourceList] = useState(0);
  const [showEvidences, setShowEvidences] = useState({});
  const [resetUserJob, setResetUserJob] = useState(0);

  const { mode } = useParams();

  const initTab = () => {
    var tnames = {
      delayed: 1,
      upcoming: 2,
      complete: 3,
    };
    return _.get(tnames, mode, 0);
  };

  const [filter, setFilter] = useState({
    tab: initTab(),
    jcat: "",
    status: "",
    mode: 1,
  }); //1: daily, 2: weekly, 3: monthly
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(Utils.perpage || 10);

  const [dtCnt, setDtCnt] = useState(moment());

  const [jcats, setJcats] = useState([]);

  const [data, setData] = useState({
    backlog: false,
    upcoming: false,
    completed: false,
  });

  const [jobs, setJobs] = useState([]);

  const addFilters = () => {
    let str = _.compact(_.map(filter, (fv, fk) => (fv !== "" ? `${fk}=${fv}` : undefined)));
    str.push("st=" + getStartDate());
    return "?" + str.join("&");
  };

  const setDate = (dir) => (e) => {
    setFilter({ ...filter });
    setDtCnt(getDate(dir));
  };

  const getDate = (dir) => {
    const dt = moment(dtCnt);
    if (filter.mode === 1) {
      dt.add("day", dir);
    } else if (filter.mode === 2) {
      dt.add("day", 7 * dir);
    } else if (filter.mode === 3) {
      dt.add("month", dir);
    }

    return dt;
  };

  const getStartDate = () => {
    if (filter.mode === 1) {
      return dtCnt.format("YYYY-MM-DD");
    } else if (filter.mode === 2) {
      return moment(dtCnt).day(1).format("YYYY-MM-DD");
    } else if (filter.mode === 3) {
      return dtCnt.startOf("month").format("YYYY-MM-DD");
    }
  };

  const getDateRange = () => {
    if (filter.mode === 1) {
      return dtCnt.format("MMM DD, YYYY");
    } else if (filter.mode === 2) {
      return moment(dtCnt).day(1).format("MMM DD, YYYY") + " - " + moment(dtCnt).day(7).format("MMM DD, YYYY");
    } else if (filter.mode === 3) {
      return dtCnt.format("MMM - YYYY");
    }
  };

  const fetchJobSummary = () => {
    setLoading(true);
    axios
      .get(Utils.apiUrl("jobs/fetchjobsummary"), Utils.apiHeaders())
      .then((res) => {
        setLoading(false);
        if (res.data.success) {
          setData({
            ...data,
            ..._.pick(res.data.data, ["backlog", "upcoming", "completed"]),
          });
          Utils.addToUserData({ jobs: res.data.data.upcoming });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(fetchJobSummary, []);

  const fetchJobs = (callback = false, targetUjid = null) => {
    setLoadingJobs(true);
    axios
      .get(Utils.apiUrl("jobs/fetchjobs") + addFilters(), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          let tmp = _.get(res, "data.jobs", []);
          if (targetUjid) {
            const jobIndex = tmp.findIndex((j) => String(j.id) === String(targetUjid));
            if (jobIndex >= 0) {
              const targetPage = Math.floor(jobIndex / pageSize) + 1;
              setPage(targetPage);
            }
          } else if (callback === false) {
            setPage(1);
          }
          setJobs(tmp);
          setJcats(_.get(res, "data.jcats", []));
          setOnLeave(_.get(res, "data.onLeave", false));
          if (callback) {
            callback(tmp);
          }
        }
        setLoadingJobs(false);
      })
      .catch((err) => {
        setLoadingJobs(false);
        console.log(err);
      });
  };

  useEffect(fetchJobs, [filter, dtCnt]);

  const hasPendingJobs = () => jobs.filter((j) => _.isEmpty(j.completed_at)).length > 0;

  const perpage = () => {
    return pageSize;
  };

  const getRecordStart = () => {
    return (page - 1) * perpage();
  };

  const getPageResults = () => {
    var st = getRecordStart();
    var tmp = jobs.slice(st, st + perpage());
    return tmp;
  };

  const updateUserJob =
    (uj, doNA = false) =>
    (e) => {
      if (!doNA && uj.require_evidence === "1") {
        setRequireEvidence(uj);
      } else {
        setRequireEvidence(false);
        let formData = new FormData();
        formData.append("ujid", uj.id);
        formData.append("na", doNA ? "1" : "0");
        updateUserJobSubmit(formData);
      }
    };

  const updateUserJobSubmit = (formData) => {
    //setLoadingJobs(true);

    let headers = Utils.apiHeaders();

    headers["headers"]["Content-Type"] = "multipart/form-data";

    return axios
      .post(Utils.apiUrl("jobs/updateuserjob"), formData, headers)
      .then((res) => {
        //setLoadingJobs(false);
        if (res.data.success) {
          setRequireEvidence(false);
          reloadUserJobs(formData.get("ujid"));
        } else {
          //window.alert(res.data.message);
        }
      })
      .catch((err) => {
        setLoadingJobs(false);
        console.log(err);
      });
  };

  const onUserJobEvidenceUpdation = (formData) => {
    setLoadingJobs(true);

    let headers = Utils.apiHeaders();

    headers["headers"]["Content-Type"] = "multipart/form-data";

    axios
      .post(Utils.apiUrl("jobs/updateuserjob"), formData, headers)
      .then((res) => {
        setLoadingJobs(false);
        if (res.data.success) {
          setShowEvidences({});
          reloadUserJobs(formData.get("ujid"));
        } else {
          //window.alert(res.data.message);
        }
      })
      .catch((err) => {
        setLoadingJobs(false);
        console.log(err);
      });
  };

  const reloadUserJobs = (ujid = null) => {
    fetchJobs((updatedJobs) => {
      if (ujid) {
        window.setTimeout(() => {
          const el = document.getElementById("jobrow-" + ujid) || document.getElementById("mob-jobrow-" + ujid);
          if (el) {
            el.scrollIntoView({ block: "center", behavior: "smooth" });
            const origBg = el.style.backgroundColor;
            const origTransition = el.style.transition;
            el.style.transition = "background-color 0.4s ease";
            el.style.backgroundColor = "rgba(16, 185, 129, 0.18)";
            window.setTimeout(() => {
              el.style.backgroundColor = origBg;
              el.style.transition = origTransition;
            }, 1800);
          }
        }, 150);
      }
    }, ujid);
    fetchJobSummary();
  };

  const jobsForDate = (dt) => {
    let alljobs = { backlog: [], upcoming: [], completed: [] };
    let tmp = jobs.filter((j) => moment(dt).startOf("day").diff(moment(j.job_date).startOf("day")) === 0);
    if (tmp.length > 0) {
      alljobs["backlog"] = tmp.filter((j) => j.completed !== "1" && moment(j.job_date).isBefore(moment().startOf("day")));
      alljobs["upcoming"] = tmp.filter(
        (j) =>
          j.completed !== "1" &&
          moment(j.job_date).isAfter(moment().startOf("day")) &&
          moment(j.job_date).startOf("day").diff(moment(dt).startOf("day"), "day") === 0
      );
      alljobs["completed"] = tmp.filter((j) => j.completed === "1");
    }
    return alljobs;
  };

  const gotoDate = (wdate) => (e) => {
    setFilter({ ...filter, jcat: "", status: "", mode: 1 });
    setDtCnt(wdate);
  };

  const dailyView = () => {
    return (
      <>
        {/* Mobile-friendly Card View (Visible on mobile/tablet screens) */}
        <div className="d-md-none mt-3">
          <div className="d-flex flex-column gap-3">
            {getPageResults().map((jrec, jCtr) => {
              let job = _.get(jrec, "jobdetails", false);
              if (job) {
                job = JSON.parse(job);
              } else {
                job = jrec;
              }

              let rescount = parseInt(jrec.rescount);
              let completed = _.get(jrec, "completed", "0") === "1" || _.get(jrec, "completed_at", false);
              let backlog = !completed && moment().startOf("day").isAfter(moment(jrec.job_date).startOf("day"));
              let label = completed ? "success" : backlog ? "danger" : "warning";
              let isToday = moment().startOf("day").diff(moment(jrec.job_date).startOf("day"), "days") === 0;
              let resfile = jrec.resfile ? jrec.resfile.split("#,#") : [];
              let evidences = completed && jrec.require_evidence === "1" ? JSON.parse(jrec.evidence) : { id: 0, evidences: [] };

              return (
                <div
                  key={jrec.id}
                  id={"mob-jobrow-" + jrec.id}
                  className="bg-white rounded-3 p-3 shadow-sm border"
                  style={{
                    borderLeft: `4px solid ${
                      completed ? "#10B981" : backlog ? "#EF4444" : "#F59E0B"
                    }`,
                  }}
                >
                  <div className="d-flex align-items-start justify-content-between gap-2 mb-2">
                    <div className="d-flex align-items-center gap-2">
                      <span
                        className={`badge rounded-pill ${
                          completed
                            ? "bg-success"
                            : backlog
                            ? "bg-danger"
                            : "bg-warning text-dark"
                        }`}
                        style={{ fontSize: "11px", fontWeight: 700 }}
                      >
                        #{Utils.addZero(jCtr + 1 + getRecordStart())}
                      </span>
                      <span
                        className="badge bg-light text-dark border px-2 py-1"
                        style={{ fontSize: "11.5px" }}
                      >
                        {isToday ? (
                          <strong className="text-primary">Today</strong>
                        ) : (
                          Utils.toLocal(jrec.job_date).format("DD MMM YYYY")
                        )}
                      </span>
                    </div>

                    {/* Resources */}
                    {rescount > 0 && (
                      <div className="d-flex align-items-center gap-1">
                        {rescount === 1 && (
                          <>
                            {_.get(resfile, "0", "") === "upload" && (
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={Utils.viewerLink(
                                  resfile[1],
                                  `resources/downloadbyjob?id=${jrec.job_id}`
                                )}
                              >
                                <img
                                  src={Utils.getFileIcon(_.get(resfile, "1", ""))}
                                  alt="Download"
                                  style={{ width: 22, height: 22 }}
                                />
                              </a>
                            )}
                            {_.get(resfile, "0", "") === "link" && (
                              <img
                                className="clickable"
                                src={`${process.env.PUBLIC_URL}/images/video.png`}
                                alt="Play Video"
                                style={{ width: 22, height: 22 }}
                                onClick={() => setShowVideo(resfile[1])}
                              />
                            )}
                            {_.get(resfile, "0", "") === "ext_link" && (
                              <a
                                href={resfile[1]}
                                target="_blank"
                                rel="noreferrer"
                                style={{ fontSize: "16px" }}
                              >
                                🔗
                              </a>
                            )}
                          </>
                        )}
                        {rescount > 1 && (
                          <img
                            className="clickable"
                            src={`${process.env.PUBLIC_URL}/images/folder.png`}
                            alt="View Resources"
                            style={{ width: 22, height: 22 }}
                            onClick={() => setShowResourceList(jrec.job_id)}
                          />
                        )}
                      </div>
                    )}
                  </div>

                  {/* Job Title */}
                  <div
                    className="fw-bold text-dark mb-3"
                    style={{ fontSize: "14px", lineHeight: "1.4" }}
                  >
                    {job.name}
                  </div>

                  {/* Actions / Status */}
                  <div className="d-flex align-items-center justify-content-between pt-2 border-top">
                    {completed ? (
                      <div className="d-flex align-items-center justify-content-between w-100">
                        <div className="d-flex flex-column">
                          <span
                            className="text-muted"
                            style={{ fontSize: "11px" }}
                          >
                            Completed at
                          </span>
                          <span
                            className="fw-semibold text-dark"
                            style={{ fontSize: "12px" }}
                          >
                            {Utils.toLocal(jrec.completed_at).format(
                              "DD MMM' YY hh:mm A"
                            )}
                          </span>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <Badge
                            className={
                              jrec.na === "1" ? "bg-secondary" : "bg-success"
                            }
                            style={{ fontSize: "12px", padding: "6px 10px" }}
                          >
                            {jrec.na === "1" ? "NA" : "Completed"}
                          </Badge>
                          {jrec.na !== "1" &&
                            jrec.require_evidence === "1" &&
                            _.get(evidences, "length", 0) > 0 && (
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-primary p-1.5 rounded"
                                title="View Evidence"
                                onClick={() =>
                                  setShowEvidences({
                                    id: jrec.id,
                                    evidences: evidences,
                                    edit: true,
                                    userJob: jrec,
                                  })
                                }
                              >
                                <img
                                  src={`${process.env.PUBLIC_URL}/images/download.png`}
                                  alt="Evidence"
                                  style={{ width: 15, height: 15 }}
                                />
                              </button>
                            )}
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary p-1.5 rounded"
                            title="Reset Job"
                            onClick={() => setResetUserJob(jrec.id)}
                          >
                            <img
                              src={`${process.env.PUBLIC_URL}/images/edit.png`}
                              alt="Reset Job"
                              style={{ width: 15, height: 15 }}
                            />
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex align-items-center justify-content-between w-100 gap-2">
                        <button
                          onClick={updateUserJob(jrec, false)}
                          className={`btn btn-${label} btn-sm flex-grow-1 py-2 d-inline-flex align-items-center justify-content-center gap-1.5 shadow-sm`}
                          style={{ fontWeight: 600, fontSize: "13px" }}
                        >
                          {jrec.countcomp > 0 ? (
                            <Badge
                              className="bg-light text-dark me-1"
                              title="Branch teammates who completed this job"
                            >
                              ✓ {jrec.countcomp}
                            </Badge>
                          ) : (
                            <Badge
                              className="bg-light text-muted me-1"
                              title="Not yet completed by teammates"
                            >
                              0
                            </Badge>
                          )}
                          {jrec.require_evidence === "1" && (
                            <img
                              src={`${process.env.PUBLIC_URL}/images/upload.png`}
                              alt="Upload"
                              style={{ width: 14, height: 14 }}
                            />
                          )}
                          Mark Complete
                        </button>
                        <button
                          onClick={updateUserJob(jrec, true)}
                          className={`btn btn-outline-secondary btn-sm px-3 py-2`}
                          style={{
                            minWidth: "60px",
                            fontWeight: 600,
                            fontSize: "13px",
                          }}
                        >
                          NA
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Desktop Table View (Visible on md+ screens) */}
        <Table bordered hover responsive className="mt-4 text-nowrap d-none d-md-table">
          <thead>
            <tr className="align-middle">
              <th style={{ width: "50px" }}>Sr. No.</th>
              <th>Job Name</th>
              <th style={{ width: "50px" }}></th>
              <th className="dueon">Due On</th>
              <th className="text-center actionbtns">Update</th>
            </tr>
          </thead>
          <tbody>
            {getPageResults().map((jrec, jCtr) => {
              let job = _.get(jrec, "jobdetails", false);
              if (job) {
                job = JSON.parse(job);
              } else {
                job = jrec;
              }

              let rescount = parseInt(jrec.rescount);

              let completed = _.get(jrec, "completed", "0") === "1" || _.get(jrec, "completed_at", false);
              let backlog = !completed && moment().startOf("day").isAfter(moment(jrec.job_date).startOf("day"));
              let label = completed ? "success" : backlog ? "danger" : "warning";
              let isToday = moment().startOf("day").diff(moment(jrec.job_date).startOf("day"), "days") === 0;
              let resfile = jrec.resfile ? jrec.resfile.split("#,#") : [];
              let evidences = completed && jrec.require_evidence === "1" ? JSON.parse(jrec.evidence) : { id: 0, evidences: [] };

              return (
                <tr key={jrec.id} id={"jobrow-" + jrec.id} className="align-middle">
                  <td>
                    <div className={`tb-lable tb-lable-${label} text-center`}>{Utils.addZero(jCtr + 1 + getRecordStart())}</div>
                  </td>
                  <td style={{ whiteSpace: "pre-wrap" }}>{job.name}</td>
                  <td style={{ width: "50px" }}>
                    {rescount > 0 && (
                      <>
                        {rescount === 1 && (
                          <>
                            {_.get(resfile, "0", "") === "upload" && (
                              <a target="_blank" rel="noreferrer" href={Utils.viewerLink(resfile[1], `resources/downloadbyjob?id=${jrec.job_id}`)}>
                                <img src={Utils.getFileIcon(_.get(resfile, "1", ""))} alt="Download" />
                              </a>
                            )}
                            {_.get(resfile, "0", "") === "link" && (
                              <img
                                className="clickable"
                                src={`${process.env.PUBLIC_URL}/images/video.png`}
                                alt="Play Video"
                                onClick={() => setShowVideo(resfile[1])}
                              />
                            )}
                            {_.get(resfile, "0", "") === "ext_link" && (
                              <a href={resfile[1]} target="_blank" rel="noreferrer">
                                🔗
                              </a>
                            )}
                          </>
                        )}
                        {rescount > 1 && (
                          <img
                            className="clickable"
                            src={`${process.env.PUBLIC_URL}/images/folder.png`}
                            alt="View Resources"
                            onClick={() => setShowResourceList(jrec.job_id)}
                          />
                        )}
                      </>
                    )}
                  </td>
                  <td className="dueon text-center">
                    <div className="d-flex flex-column align-items-center justify-content-center gap-1">
                      <span className="badge bg-light text-dark px-2 py-1.5" style={{ fontSize: "12px", border: "1px solid #E2E8F0" }}>
                        {isToday && <b>Today</b>}
                        {!isToday && <span>{Utils.toLocal(jrec.job_date).format("DD MMM YY")}</span>}
                      </span>
                    </div>
                  </td>

                  <td className="text-center actionbtns">
                    {completed && (
                      <div className="d-inline-flex flex-column align-items-center justify-content-center gap-1 p-1 bg-light rounded" style={{ border: "1px solid #E2E8F0" }}>
                        <span className="text-dark fw-semibold" style={{ fontSize: "11.5px" }}>
                          {Utils.toLocal(jrec.completed_at).format("DD MMM' YY hh:mm A")}
                        </span>
                        <div className="d-flex align-items-center gap-1">
                          <Badge className={jrec.na === "1" ? "bg-secondary" : "bg-success"} style={{ fontSize: "11px" }}>
                            {jrec.na === "1" ? "NA" : "Complete"}
                          </Badge>
                          {jrec.na !== "1" && jrec.require_evidence === "1" && _.get(evidences, "length", 0) > 0 && (
                            <img
                              src={`${process.env.PUBLIC_URL}/images/download.png`}
                              alt="Evidence"
                              title="View Evidence"
                              className="clickable ms-1"
                              style={{ width: 14, height: 14 }}
                              onClick={() =>
                                setShowEvidences({
                                  id: jrec.id,
                                  evidences: evidences,
                                  edit: true,
                                  userJob: jrec,
                                })
                              }
                            />
                          )}
                          {completed && (
                            <img
                              className="clickable ms-1"
                              src={`${process.env.PUBLIC_URL}/images/edit.png`}
                              alt="Reset Job"
                              title="Reset Job"
                              width="14"
                              onClick={() => setResetUserJob(jrec.id)}
                            />
                          )}
                        </div>
                      </div>
                    )}
                    {!completed && (
                      <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap flex-sm-nowrap">
                        <button
                          onClick={updateUserJob(jrec, false)}
                          className={`btn btn-outline-${label} btn-sm px-2.5 py-1 d-inline-flex align-items-center justify-content-center gap-1`}
                          style={{ minWidth: "92px", fontWeight: 600, fontSize: "12.5px" }}
                        >
                          {jrec.countcomp > 0 && (
                            <Badge className="bg-success me-1" title="Completed this job by branch users">
                              {jrec.countcomp}
                            </Badge>
                          )}
                          {jrec.countcomp === 0 && (
                            <Badge className="bg-danger me-1" title="no one completed this job by branch users">
                              {jrec.countcomp}
                            </Badge>
                          )}
                          {jrec.require_evidence === "1" && <img src={`${process.env.PUBLIC_URL}/images/upload.png`} alt="Upload" style={{ width: 14, height: 14 }} />} Complete
                        </button>
                        <button
                          onClick={updateUserJob(jrec, true)}
                          className={`btn btn-outline-${label} btn-sm px-2 py-1`}
                          style={{ minWidth: "55px", fontWeight: 600, fontSize: "12.5px" }}
                        >
                          NA
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        {jobs.length > 0 && showPagination()}
      </>
    );
  };

  const confirmResetUserJob = () => {
    return (
      <Modal size="md" show={true} centered>
        <Modal.Header style={{ borderBottom: "0" }} className="pb-0 mb-0">
          <img
            src={`${process.env.PUBLIC_URL}/images/close.png`}
            className="ms-auto clickable"
            title="Close"
            alt="Close"
            onClick={() => setResetUserJob(0)}
          />
        </Modal.Header>
        <Modal.Body className="bg-white text-center px-5">
          <h3>Are you sure you want to reset the job status?</h3>

          <div className="text-danger my-4">
            <img src={`${process.env.PUBLIC_URL}/images/alert.png`} className="mb-1 align-middle" width="20" valign="middle" alt="Information" />{" "}
            <b>All evidence will be lost</b>
          </div>
          <Button variant="primary" className="d-block mx-auto mt-2 mb-2 w-50" onClick={resetThisUserJob}>
            Yes
          </Button>
          <Button variant="outline-danger" className="d-block mx-auto w-50" onClick={() => setResetUserJob(0)}>
            No
          </Button>
        </Modal.Body>
      </Modal>
    );
  };

  const resetThisUserJob = () => {
    const ujid = resetUserJob;
    setResetUserJob(0);
    axios
      .post(Utils.apiUrl("jobs/resetuserjob"), `ujid=${ujid}`, Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          reloadUserJobs(ujid);
        } else {
          window.alert(res.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const showPagination = () => {
    const totalPages = Math.ceil(jobs.length / perpage());
    return (
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 pt-3 border-top">
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <span className="small text-muted fw-semibold">
            Showing {(page - 1) * perpage() + 1} to {Math.min(page * perpage(), jobs.length)} of {jobs.length} jobs
          </span>
          <div className="d-flex align-items-center gap-1.5 ms-sm-2">
            <span className="small text-muted">Per page:</span>
            <select
              className="form-select form-select-sm"
              style={{ width: "75px", padding: "2px 8px", fontSize: "12px" }}
              value={pageSize}
              onChange={(e) => {
                setPageSize(parseInt(e.target.value));
                setPage(1);
              }}
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value={jobs.length}>All</option>
            </select>
          </div>
        </div>

        {totalPages > 1 && (
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary rounded-pill px-3"
              onClick={() => setPage(p => Math.max(1, p - 1))}
              disabled={page === 1}
            >
              ← Previous
            </button>
            <div className="d-flex align-items-center gap-1">
              <span className="small text-muted">Page</span>
              <select
                className="form-select form-select-sm"
                style={{ width: "65px", padding: "2px 6px", fontSize: "12px" }}
                value={page}
                onChange={(e) => setPage(parseInt(e.target.value))}
              >
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((pNum) => (
                  <option key={pNum} value={pNum}>
                    {pNum}
                  </option>
                ))}
              </select>
              <span className="small text-muted">of {totalPages}</span>
            </div>
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary rounded-pill px-3"
              onClick={() => setPage(p => Math.min(totalPages, p + 1))}
              disabled={page >= totalPages}
            >
              Next →
            </button>
          </div>
        )}
      </div>
    );
  };

  const weeklyView = () => {
    let curjobs = [];
    let wkdt = getStartDate();
    let wkdaydt = null;
    return (
      <Table responsive className="h-100" style={{ minHeight: "300px" }}>
        <tr>
          {_.fill(new Array(7), 0).map((v, k) => {
            wkdaydt = moment(wkdt).add(k, "day");
            curjobs = jobsForDate(wkdaydt);

            return (
              <td key={k} className="align-top h-100 d-block d-md-table-cell weeklybox">
                <div className="d-flex flex-column h-100 weekcolumn p-0 clickable" title="Click to view daily" onClick={gotoDate(wkdaydt)}>
                  <div className="weekdate">
                    {wkdaydt.format("DD")} <span className="weekday d-inline d-md-none">{wkdaydt.format("dddd")}</span>
                  </div>
                  <div className="weekday d-none d-md-block">{wkdaydt.format("dddd")}</div>
                  <Card className="m-0 p-0 flex-grow-1 h-100 border-0">
                    {["backlog", "upcoming", "completed"].map((cat) => (
                      <div className={`weekcol weekcol-${cat} my-1`}>
                        {_.slice(curjobs[cat], 0, 3).map((j) => (
                          <div className="py-1 ms-1">{_.truncate(_.get(JSON.parse(j.jobdetails), "name", ""), { length: 30 })}</div>
                        ))}
                      </div>
                    ))}
                  </Card>
                </div>
              </td>
            );
          })}
        </tr>
      </Table>
    );
  };

  const drawDateBox = (dt, sameMonth = true) => {
    if (_.isNull(dt)) {
      return <Card className="m-0 p-0 monthbox monthbox-empty mr-1 my-1"></Card>;
    }

    let curjobs = jobsForDate(dt);

    if (_.flatten(_.values(curjobs)).length === 0) {
      return (
        <Card className={`m-0 p-0 monthbox mr-1 my-1 bg-${sameMonth ? "white" : "grey"}`}>
          <Card.Header className={`d-block d-md-none text-${sameMonth ? "info bg-white border-info" : "secondary"}`}>
            <span className="monthdate">{moment(dt).format("DD")}</span>
            <span className="monthday">{moment(dt).format("dddd")}</span>
          </Card.Header>
          <div className="d-flex flex-column h-100">
            <div className="flex-grow-1 p-1"></div>
            <div className="flex-growth-1 text-end pe-2 text-info d-none d-md-block">
              <b>{moment(dt).format("DD")}</b>
            </div>
          </div>
        </Card>
      );
    }

    return (
      <Card className="m-0 p-0 monthbox mr-1 my-1 clickable" title="Click to Daily View" onClick={gotoDate(moment(dt))}>
        <Card.Header className={`d-block d-md-none bg-${sameMonth ? "white" : "grey"} text-info border-info`}>
          <span className="monthdate">{moment(dt).format("DD")}</span>
          <span className="monthday">{moment(dt).format("dddd")}</span>
        </Card.Header>

        <div className="d-flex flex-column h-100">
          <div className="flex-grow-1 p-1">
            {["backlog", "upcoming", "completed"].map((cat) => (
              <div key={cat} className={`weekcol weekcol-${cat} my-1`}>
                {_.slice(curjobs[cat], 0, 1).map((j, jidx) => (
                  <div key={j.id || jidx} className="py-1 ms-1 d-flex flex-row align-items-center">
                    <div className="text-start p-0 small text-truncate" style={{ fontSize: "11px", maxWidth: "110px" }}>
                      {_.truncate(_.get(JSON.parse(j.jobdetails), "name", ""), {
                        length: 30,
                      })}
                    </div>
                    {curjobs[cat].length > 1 && <div className={`month-count ${cat} ms-auto`}>+{curjobs[cat].length - 1}</div>}
                  </div>
                ))}
              </div>
            ))}
          </div>

          <div className="flex-growth-1 text-end pe-2 text-info d-none d-md-block">
            <b>{moment(dt).format("DD")}</b>
          </div>
        </div>
      </Card>
    );
  };

  const monthlyView = () => {
    let mdt = getStartDate();

    return (
      <>
        <Row className="d-md-none mt-2">
          {Utils.getMonthDates(mdt).map((v1) => (
            <Col xs={6} className="p-0 px-1" key={v1}>
              {drawDateBox(v1, moment(mdt).month() === moment(v1).month())}
            </Col>
          ))}
        </Row>

        <Table responsive className="h-100 d-none d-md-table" style={{ minHeight: "300px" }}>
          <tr>
            {Utils.weekdays().map((v, k) => {
              return (
                <td key={k} className="align-top h-100" style={{ width: 100 / 7 + "%" }}>
                  <div className="d-flex flex-column h-100 p-0">
                    <div className="monthweek">{v.substring(0, 3).toUpperCase()}</div>
                    {Utils.getAllWeekDates(mdt, k + 1).map((v1) => drawDateBox(v1))}
                  </div>
                </td>
              );
            })}
          </tr>
        </Table>
      </>
    );
  };

  const setTab = (t) => {
    setFilter({ ...filter, tab: t });
  };

  const showList = () => {
    const tabname = ["Backlog (Till Date)", "Upcoming (Today)", "Complete (This Week)"];
    return (
      <Card border="light" className="shadow table-section mt-2 p-0">
        <Card.Header className="m-0 p-2 pt-3">
          <Card.Title>
            <Row>
              <Col>
                <b>{tabname[filter.tab - 1]}</b>
              </Col>
              <Col className="text-end">
                {!loadingJobs && filter.tab === 1 && jobs.length > 0 && (
                  <Button variant="primary" className="me-3" onClick={markAllNA}>
                    Mark All as NA
                  </Button>
                )}
                <Button onClick={() => setFilter({ ...filter, tab: 0 })}>X</Button>
              </Col>
            </Row>
          </Card.Title>
        </Card.Header>
        <Card.Body>
          {loadingJobs && (
            <Alert variant="success" className="p-3">
              <p className="loading-msg">Fetching Jobs</p>
              <ProgressBar variant="success" animated now={100} />
            </Alert>
          )}

          {!loadingJobs && jobs.length === 0 && (
            <Alert variant="warning" className="mt-4 p-3">
              No jobs found!
            </Alert>
          )}

          {!loadingJobs && jobs.length > 0 && dailyView()}
        </Card.Body>
      </Card>
    );
  };

  const markAllCatNA = () => {
    if (!window.confirm("You are going to mark all jobs in this Category as NA, continue?")) {
      return;
    }
    setLoadingJobs(true);

    var params = filter.tab === 1 ? "mode=backlog&cat=" + filter.jcat : `st=${getStartDate()}&cat=${filter.jcat}`;

    axios
      .post(Utils.apiUrl("jobs/markallna"), params, Utils.apiHeaders())
      .then((res) => {
        setLoadingJobs(false);
        if (res.data.success) {
          reloadUserJobs();
        } else {
          //window.alert(res.data.message);
        }
      })
      .catch((err) => {
        setLoadingJobs(false);
        console.log(err);
      });
  };

  const markAllNA = () => {
    if (!window.confirm("You are going to mark all jobs as NA, continue?")) {
      return;
    }
    setLoadingJobs(true);

    var params = filter.tab === 1 ? "mode=backlog" : `st=${getStartDate()}`;

    axios
      .post(Utils.apiUrl("jobs/markallna"), params, Utils.apiHeaders())
      .then((res) => {
        setLoadingJobs(false);
        if (res.data.success) {
          reloadUserJobs();
        } else {
          //window.alert(res.data.message);
        }
      })
      .catch((err) => {
        setLoadingJobs(false);
        console.log(err);
      });
  };
  if (!Utils.hasAccess(3)) {
    return (
      <>
        {!userData.is_super_user && <h1 className="alert alert-danger p-5 mt-5">No access!</h1>}
        {userData.is_super_user && <>
            <h1 className="alert alert-danger p-4 mt-4">You current plan is restricted to use this module, please Upgrade!</h1>
            <ChoosePlans onPayment={() => { window.location.reload(); }} />
        </>}
      </>
    );
  }

  return (
    <div className="mt-4">
      {loading && (
        <Alert variant="info" className="p-3">
          <p className="loading-msg">Fetching Job data</p>
          <ProgressBar variant="info" animated now={100} />
        </Alert>
      )}
      {!loading && (
        <>
          <JobSummary stats={{ ...data }} onFilter={setTab} />

          {filter.tab !== 0 && showList()}
          {filter.tab === 0 && (
            <>
              <Row className="mt-3 mt-sm-4">
                <Col>
                  <Form>
                    <Row className="gx-1">
                      <Col>
                        <select
                          className="form-control form-control-select form-select shadow-cst filters"
                          value={filter.jcat}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              jcat: e.currentTarget.value,
                            })
                          }
                        >
                          <option value="">Category</option>
                          {jcats.map((jc) => (
                            <option value={jc.id}>{jc.value}</option>
                          ))}
                        </select>
                      </Col>
                      <Col className="d-none d-sm-block">
                        <select
                          className="form-control form-control-select form-select shadow-cst filters"
                          value={filter.status}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              status: e.currentTarget.value,
                            })
                          }
                        >
                          <option value="">Status</option>
                          <option value="backlog">Backlog</option>
                          <option value="upcoming">Upcoming</option>
                          <option value="completed">Completed</option>
                        </select>
                      </Col>
                      <Col className="col-3">
                        <Button
                          variant="light"
                          className="style1 w-100 radius-right shadow-cst p-0 filters"
                          onClick={(e) => setFilter({ ...filter, jcat: "", status: "" })}
                        >
                          Clear filter
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Col>
              </Row>

              <Row className="mt-3 mt-sm-4">
                <Col>
                  <Row className="d-sm-none">
                    <Col xs={4} className="m-0 p-0 ps-3">
                      <Button
                        variant={`${filter.mode === 1 ? "primary" : "light"}`}
                        className="w-100 rounded-0 roundleft"
                        onClick={(e) => {
                          setDtCnt(moment());
                          setFilter({ ...filter, mode: 1 });
                        }}
                      >
                        Daily
                      </Button>
                    </Col>
                    <Col xs={4} className="m-0 p-0">
                      <Button
                        variant={`${filter.mode === 2 ? "primary" : "light"}`}
                        className="w-100 rounded-0"
                        onClick={(e) => {
                          setFilter({ ...filter, mode: 2 });
                        }}
                      >
                        Weekly
                      </Button>
                    </Col>
                    <Col xs={4} className="m-0 p-0 pe-3">
                      <Button
                        variant={`${filter.mode === 3 ? "primary" : "light"}`}
                        className="w-100 rounded-0 roundright"
                        onClick={(e) => {
                          setFilter({ ...filter, mode: 3 });
                        }}
                      >
                        Monthly
                      </Button>
                    </Col>
                  </Row>
                  <Card className="shadow table-section p-sm-3 border-0 bottomRoundedBox mx-1 mx-sm-0">
                    <Card.Body>
                      <Row>
                        <Col className="d-flex justify-content-between">
                          <ButtonGroup
                            aria-label="Basic example"
                            className="shadow btn-group order-3 order-lg-1 d-none d-lg-block d-sm-none d-xl-block"
                          >
                            <Button variant="light" className="radius-left" onClick={setDate(-1)}>
                              <img src={`${process.env.PUBLIC_URL}/images/arrow-left.png`} alt="Previous" />
                            </Button>
                            <Button variant="primary"> {getDateRange()} </Button>
                            <Button variant="light" className="radius-right" onClick={setDate(1)}>
                              <img src={`${process.env.PUBLIC_URL}/images/arrow-right.png`} alt="Next" />
                            </Button>
                          </ButtonGroup>

                          <ButtonGroup aria-label="Basic example" className="d-none d-sm-inline shadow btn-group order-1 order-lg-3 flex-xs-fill">
                            {hasPendingJobs() && filter.jcat !== "" && (
                              <Button variant="primary" className="me-3" onClick={markAllCatNA}>
                                Mark Cat as NA
                              </Button>
                            )}
                            {hasPendingJobs() && (
                              <Button variant="primary" className="me-3" onClick={markAllNA}>
                                Mark All as NA
                              </Button>
                            )}
                            <Button
                              variant={`${filter.mode === 1 ? "primary" : "light"}`}
                              className="radius-left"
                              onClick={(e) => {
                                setDtCnt(moment());
                                setFilter({ ...filter, mode: 1 });
                              }}
                            >
                              Daily
                            </Button>
                            <Button
                              variant={`${filter.mode === 2 ? "primary" : "light"}`}
                              className=""
                              onClick={(e) => {
                                setFilter({ ...filter, mode: 2 });
                              }}
                            >
                              Weekly
                            </Button>
                            <Button
                              variant={`${filter.mode === 3 ? "primary" : "light"}`}
                              className="radius-right"
                              onClick={(e) => {
                                setFilter({ ...filter, mode: 3 });
                              }}
                            >
                              Monthly
                            </Button>
                          </ButtonGroup>
                        </Col>
                      </Row>

                      <Row className="mt-3 d-sm-none d-block">
                        <Col className="d-flex justify-content-center">
                          <ButtonGroup aria-label="Basic example" className="shadow btn-group">
                            <Button variant="light" className="radius-left" onClick={setDate(-1)}>
                              <img src={`${process.env.PUBLIC_URL}/images/arrow-left.png`} alt="Previous" />
                            </Button>
                            <Button variant="primary"> {getDateRange()} </Button>
                            <Button variant="light" className="radius-right" onClick={setDate(1)}>
                              <img src={`${process.env.PUBLIC_URL}/images/arrow-right.png`} alt="Next" />
                            </Button>
                          </ButtonGroup>
                        </Col>
                        <Col className="d-flex justify-content-center mt-3">
                          <>
                            {hasPendingJobs() && filter.jcat !== "" && (
                              <Button variant="primary" className="me-3" onClick={markAllCatNA}>
                                Mark Cat as NA
                              </Button>
                            )}
                            {hasPendingJobs() && (
                              <Button variant="primary" className="me-3" onClick={markAllNA}>
                                Mark All as NA
                              </Button>
                            )}
                          </>
                        </Col>
                      </Row>

                      {loadingJobs && (
                        <Alert variant="success" className="p-3">
                          <p className="loading-msg">Fetching Jobs</p>
                          <ProgressBar variant="success" animated now={100} />
                        </Alert>
                      )}

                      {!loadingJobs && jobs.length === 0 && (
                        <Alert variant="warning" className="mt-4 p-3">
                          No jobs found!
                        </Alert>
                      )}

                      {!loadingJobs && jobs.length > 0 && (
                        <>
                          {filter.mode === 1 && dailyView()}
                          {filter.mode === 2 && weeklyView()}
                          {filter.mode === 3 && monthlyView()}
                        </>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </>
          )}

          {requireEvidence !== false && (
            <JobEvidence userJob={requireEvidence} onHide={() => setRequireEvidence(false)} userJobSubmit={updateUserJobSubmit} />
          )}
        </>
      )}

      {showResourceList > 0 && <JobResources jid={showResourceList} onHide={() => setShowResourceList(0)} />}

      {_.get(showEvidences, "evidences", []).length > 0 && (
        <EvidenceList
          data={showEvidences}
          onHide={() => setShowEvidences({})}
          userJobSubmit={onUserJobEvidenceUpdation}
          onEvidenceChange={() => fetchJobs()}
        />
      )}

      {resetUserJob > 0 && confirmResetUserJob()}

      <Modal size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={showVideo !== ""} onHide={() => setShowVideo("")}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Video Resource</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3" style={{ background: "#F8FAFC" }}>
          <VideoPlayer src={showVideo} title="Video Resource" />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Jobs;
